import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import DashboardAdmin from './Admin/DashboardAdmin';
import { useAuth } from '../../context/AuthContext';
import DashboardDirector from './Director/DashboardDirector';
import DashboardDocente from './Docente/DashboardDocente';
import HeroHeader from '../../components/HeroHeader';
import dashboard from '../../assets/dashboard.png';

export default function DashboardPrincipal() {
  const { user } = useAuth();
  const role = user?.rol?.nombre;
  const rolSeguro = role?.toUpperCase();

  const renderContenido = () => {
    if (rolSeguro === 'ADMIN') {
      return <DashboardAdmin />;
    }
    if (rolSeguro === 'DIRECTOR') {
      return <DashboardDirector />;
    }
    if (rolSeguro === 'DOCENTE' || rolSeguro === 'PROFESOR') {
      return <DashboardDocente />;
    }

    return (
      <Container maxWidth="xxl">
        <Typography variant="h6" color="error">
          Acceso denegado: Rol no reconocido.
        </Typography>
      </Container>
    );
  };

  const nombreDistrito = user?.ubicacion?.distrito || "tu Distrito";

  const textoDescripcion = rolSeguro === 'ADMIN'
    ? "Explora un consolidado general del progreso de todas las sesiones de aprendizaje generadas y en proceso."
    : `Explora un consolidado general del progreso de las sesiones de aprendizaje generadas y en proceso en el Distrito de ${nombreDistrito}.`;

  return (
    <Box sx={{ marginBottom: 2 }}>
      <Box sx={{ py: 4, px: { xs: 0, lg: 4 } }}>
        <HeroHeader
          img={dashboard}
          subtitle="MÓDULO PLANIFICADOR DE SESIONES"
          title="Repositorio de Sesiones"
          description={textoDescripcion}
          maxWidth="xxl"
        />
      </Box>

      {renderContenido()}
    </Box>
  );
}